import { mapMemberStatusFromDTO } from '@/modules/common/mappers/member-status.mapper';
import { TeamMemberFullResponse } from '@/modules/team/types/dto/response/team-member-full-response';
import { TeamMember } from '@/modules/team/types/team-member';

import { mapTeamMemberBillingFromResponse } from './team-member-billing.mapper';
import { mapTeamMemberCapacityFromResponse } from './team-member-capacity.mapper';
import { mapTeamMemberInfoFromResponse } from './team-member-info.mapper';
import { mapIntegrationsFromResponse } from './team-member-integration.mapper';

/**
 * Maps full team member response to complete domain model
 * Combines info, capacity, billing, and integrations sections
 * Uses the backend-provided displayStatus field
 */
export const mapTeamMemberFullFromResponse = (response: TeamMemberFullResponse): TeamMember => {
  return {
    id: response.id.toString(),
    ...mapTeamMemberInfoFromResponse(response.info),
    ...mapTeamMemberCapacityFromResponse(response.capacity),
    ...mapTeamMemberBillingFromResponse(response.billing),
    status: mapMemberStatusFromDTO(response.displayStatus),
    integrations: mapIntegrationsFromResponse(response.integrations.integrations),
    nextArchiveDate: response.toArchiveAt ?? undefined,
    nextUnarchiveDate: response.toUnarchiveAt ?? undefined,
  } as TeamMember;
};
